import { theme } from '../../../theme';
import type { SymptomCount } from '../types/dashboard.types';

type TopItemsListProps = {
  title: string;
  items: SymptomCount[];
  accentColor: string;
  barColor: string;
};

export const TopItemsList = ({ title, items, accentColor, barColor }: TopItemsListProps) => {
  const maxCount = items.length > 0 ? items[0].count : 1;

  if (items.length === 0) {
    return (
      <div className={theme.card.padded}>
        <h3 className={`text-sm font-semibold ${theme.text.heading} mb-3`}>{title}</h3>
        <p className={`text-xs ${theme.text.muted} text-center py-6`}>No data yet</p>
      </div>
    );
  }

  return (
    <div className={theme.card.padded}>
      <h3 className={`text-sm font-semibold ${theme.text.heading} mb-4`}>{title}</h3>
      <div className="space-y-3">
        {items.map(({ name, count }, i) => {
          const pct = maxCount > 0 ? (count / maxCount) * 100 : 0;
          return (
            <div key={name}>
              <div className="flex items-center justify-between mb-1">
                <span className={`text-xs ${theme.text.body} truncate pr-2`}>{name}</span>
                <span className={`text-xs font-bold ${accentColor} tabular-nums`}>{count}</span>
              </div>
              <div className="h-1.5 rounded-full dark:bg-white/[0.06] bg-gray-100 overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all duration-700 ease-out ${barColor}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
